var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_21379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4209 23.9998H2.57915C1.15489 23.9998 0 22.8451 0 21.4206V2.57915C0 1.15489 1.15489 0 2.57915 0H21.4209C22.8451 0 24 1.15489 24 2.57915V21.4209C24 22.8451 22.8451 23.9998 21.4209 23.9998Z",
    fill: "#CCF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4209 24C22.8451 24 24 22.8453 24 21.4208V20.5015L16.9643 13.6718C16.2544 12.9828 15.1256 12.9816 14.4146 13.6693L9.76434 18.1665V24H21.4209Z",
    fill: "#B2E59C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6906 24.0005L7.99072 12.4242C7.0114 10.9519 4.94261 10.715 3.65559 11.9277L0 15.3732V21.4216C0 22.8459 1.15489 24.0008 2.57915 24.0008H15.6906V24.0005Z",
    fill: "#B2E59C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5824 6.88694C19.5824 8.30456 18.4333 9.45357 17.0157 9.45357C15.5984 9.45357 14.4491 8.30456 14.4491 6.88694C14.4491 5.46958 15.5984 4.32031 17.0157 4.32031C18.4333 4.32031 19.5824 5.46958 19.5824 6.88694Z",
    fill: "#F4DE7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_21379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.ff7c510db579c17cd3c0112934d1dac0.svg";
export { ForwardRef as ReactComponent };